import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbNavigationService, ConfigurationService, TrackingV2Service, UserService } from '@draeger-academy/common';
import { AuthenticationService } from '@draeger-academy/common/lib/services/authentication/authentication.service';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'da-order-process',
    templateUrl: './order-process.component.html',
    styleUrls: ['./order-process.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class OrderProcessComponent implements OnInit {
    public courses;
    public courseUrl;
    public activeStep = 0;
    public showLogin: boolean = true;
    public _$activeStep: BehaviorSubject<Number> = new BehaviorSubject(0);
    public _$showLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public _$showSteper: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private _subscription: Subscription;
    public portal: string;
    public portalForTracking: string;

    constructor(
        private route: ActivatedRoute,
        private _breadcrumbNavigationService: BreadcrumbNavigationService,
        private _configurationService: ConfigurationService,
        private _trackingV2Service: TrackingV2Service,
        private _cartService: CartService,
        private _authenticationService: AuthenticationService,
        private _userService: UserService
    ) {}

    public get activeStep$(): Observable<Number> {
        return this._$activeStep.asObservable();
    }

    public get showLogin$(): Observable<boolean> {
        return this._$showLogin.asObservable();
    }

    ngOnInit() {
        window.scrollTo(0, 0);
        localStorage.setItem('showLogin', 'true');
        this._breadcrumbNavigationService.initBreadcrumb('checkout');
        this.activeStep = 0;

        if (this.route.queryParams)
            this._subscription = this.route.queryParams.subscribe((params) => {
                let isBookingPerson = Boolean(params['bookingPerson']) ? true : false;
                if (isBookingPerson) this.activeStep = 1;
            });

        this._cartService.activeStep$.subscribe((activeStep) => {
            this.activeStep = activeStep;
            this._$activeStep.next(activeStep);
        });

        this._authenticationService.loggedIn().subscribe((data) => {
            if (data && data.token) {
                this._$showLogin.next(false);
            } else {
                this._$showLogin.next(true);
            }
        });

        const isPortal = this._configurationService.isPartnerPage();
        const currentPortal = this._configurationService.portalId;
        let site = this._configurationService.getSiteFromUrl();
        if (site) {
            site = this._configurationService.getSiteFromUrl().site;
        }
        const _site = isPortal ? currentPortal : site;

        localStorage.removeItem(`showMoreCourses${_site}`);

        this._configurationService.currentPortal$.subscribe((portal) => {
            if (portal) {
                this.portal = portal;
                this.portalForTracking = this.portal.toUpperCase().replace(new RegExp('-', 'g'), '_');
                this._trackPage();
            }
        });

        this._trackPage();
    }

    private _trackPage() {
        this._trackingV2Service.loadTrackingScript();
        this._trackingV2Service.trackPage({
            template: 'OrderProcessPage',
            title: 'Dräger Academy Partnerportal ' + this.portalForTracking + ' | OrderProcess Page'
        });
    }

    ngOnDestroy() {
        if (this._subscription) {
            this._subscription.unsubscribe();
        }
        this._breadcrumbNavigationService.resetBreadcrumb();
    }

    goToStep(number) {
        this.activeStep = Number(number);
        localStorage.setItem('showLogin', 'false');
        window.scrollTo(0, 0);
        this.showLogin = false;
    }

    showSteper(show) {
        this._$showLogin.next(show);
    }
}
